// views/Dashboard/Bonuses/components/CustomBonusForm/CustomBonusForm.tsx
import { useState, type FormEvent, type ChangeEvent } from 'react';
import Button from '../../../../../components/common/Button/Button';
import { BonusType, Company, CustomBonus, User } from '../../../../../Entities';
import { useAuth } from '../../../../../contexts/AuthContext';
import { notify } from '../../../../../components/common/Toast/toastBridge';
import styles from './CustomBonusForm.module.css';

interface CustomBonusFormProps {
  onClose: () => void;
}

const CustomBonusForm = ({ onClose }: CustomBonusFormProps) => {
  const { user, setUser } = useAuth();
  const [formData, setFormData] = useState<any>({
    name: '',
    company: '',
    bonus_type_name: 'live',
    reached_profit: '',
  });
  const [processing, setProcessing] = useState(false);

  const handleCustomBonusCreation = async (e: FormEvent) => {
    e.preventDefault();
    if (!(formData.name && formData.company && formData.bonus_type_name && formData.reached_profit)) {
      notify.warning('Jsou povinná veškerá pole');
      return;
    }
    try {
      setProcessing(true);
      await CustomBonus.create(formData);

      if (user) {
        user.bonus_revenue += Math.round(Number(formData.reached_profit) * 100) / 100;
        user.bonus_history_len++;
        setUser(new User({ ...user }));
      }
      onClose();
    } catch (error) {
      console.log(error);
      notify.error('Nepodařilo se uložit customizovaný bonus, zkuste to prosím později');
    } finally {
      setProcessing(false);
    }
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData((prev: any) => ({ ...prev, [name]: value }));
  };

  return (
    <div className={styles.bonusForm}>
      <form>
        <div className={styles.section}>
          <h3>📋 Základní informace</h3>
          <div className={styles.formGrid}>
            <div className={styles.formGroup}>
              <label htmlFor="name">Název bonusu *</label>
              <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} className="form-input" required />
            </div>

            <div className={styles.formGroup}>
              <label htmlFor="bonus_type_name">Typ bonusu *</label>
              <select id="bonus_type_name" name="bonus_type_name" value={formData.bonus_type_name} onChange={handleChange} className="form-input" required>
                {BonusType.values.map((bonus_type) => (
                  <option key={bonus_type.id} value={bonus_type.name}>
                    {bonus_type.label}
                  </option>
                ))}
              </select>
            </div>

            <div className={styles.formGroup}>
              <label htmlFor="company">Společnost *</label>
              <select
                id="company"
                name="company"
                value={formData.company?.name || ''}
                onChange={(e) => {
                  const selectedCompany = Company.values.find((c) => c.name === e.target.value);
                  setFormData((prev: any) => ({ ...prev, company: selectedCompany }));
                }}
                className="form-input"
                required
              >
                <option value="">Vyberte společnost</option>
                {Company.values.map((company) => (
                  <option key={company.id} value={company.name}>
                    {company.name}
                  </option>
                ))}
              </select>
            </div>

            <div className={styles.formGroup}>
              <label htmlFor="reached_profit">Dosažený zisk *</label>
              <input type="number" id="reached_profit" name="reached_profit" value={formData.reached_profit} onChange={handleChange} className="form-input" required />
            </div>
          </div>
        </div>
      </form>

      <div className={styles.formActions}>
        <Button type="button" variant="secondary" onClick={onClose}>
          Zrušit
        </Button>
        <Button type="submit" variant="primary" onClick={handleCustomBonusCreation} disabled={processing}>
          Přidat
        </Button>
      </div>
    </div>
  );
};

export default CustomBonusForm;
